const EFFECTIVE_DATE = '8/24/2026';

export const SCRIBE_USAGE_AGREEMENT = `# Scribe Usage Agreement

**Effective Date:** ${EFFECTIVE_DATE}

This is the usage agreement for Rescue Ally's **Scribe** feature. It is presented in the Rescue Ally app and accepted in-app before Scribe can be used; this page publishes the same terms for reference.

## Preview

Scribe is in preview. Scribe uses an on-device language model to transcribe the patient interview and suggest observations. Language models are not perfect and will sometimes get things wrong, so you must review and edit every observation before relying on it. You, the rescuer, remain responsible for what goes into the assessment.

## On-Device Processing

All language-model processing happens on your device. Your recordings are never sent to a third-party service such as OpenAI or Anthropic.

## Recordings Are Securely Backed Up

Your Scribe recordings — audio and transcript — are securely uploaded to Rescue Ally along with the rest of your patient assessment so that you can access them in the future. These recordings may be used by Rescue Ally to improve the feature. This data is never shared with anyone, and like all Rescue Ally data it is kept in HIPAA-compliant storage.

## Deleting Recordings

You can delete a recording anytime; deleting an assessment removes its audio from our servers.

---

For more about how we handle your data, see the [Rescue Ally Privacy Policy](/privacy). Questions? Contact [privacy@rescueally.org](mailto:privacy@rescueally.org).
`;
